(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_spec-table"] && !Shopify.designMode) return;
  try {
    class SpecTableDetails extends HTMLElement {
    #desktop = window.matchMedia('(width >= 750px)');

    connectedCallback() {
      this.#desktop.addEventListener('change', this.#sync);
      document.addEventListener('shopify:block:select', this.#onBlockSelect);
      this.#sync();
    }

    disconnectedCallback() {
      this.#desktop.removeEventListener('change', this.#sync);
      document.removeEventListener('shopify:block:select', this.#onBlockSelect);
    }

    get #details() {
      return this.querySelector('details');
    }

    #sync = () => {
      const details = this.#details;
      if (!details) return;

      if (this.#desktop.matches) {
        // Drop the group first, otherwise opening one closes the others
        details.removeAttribute('name');
        details.open = true;
      } else {
        details.open = false;
        details.name = this.dataset.group;
      }
    };

    // Open the table when its block is selected in the theme editor
    #onBlockSelect = (event) => {
      if (event.target instanceof Node && event.target.contains(this) && this.#details) {
        this.#details.open = true;
      }
    };
  }

  if (!customElements.get('spec-table-details')) {
    customElements.define('spec-table-details', SpecTableDetails);
  }
  } catch(e) { console.error(e); }
})();

})();
